export const ghostClickDebounce = (onClick: () => void, delay = 150) => {
  setTimeout(onClick, delay);
};
